export default "__VITE_ASSET__DDIc8GO4__"